import { Box } from "@mui/material";
import React, { useState } from "react";
import PolicyInput from "./components/PolicyInput";
import { getClaimStatus } from "../../services/guest";
import ClaimProgress from "./components/ClaimProgress";
import { useToast } from "../../hooks/useToast";
import WarningPopup from "../../components/WarningPopup";

export default function ClaimStatus() {
  const [claimStatusData, setClaimStatusData] = useState<any>({});
  const [idType, setIdType] = useState<"policy" | "claim">("policy");
  const [idValue, setIdValue] = useState("");
  const [showClaimProgress, setShowClaimProgress] = useState(false);
  const [showWarning, setShowWarning] = useState(false);
  const [warningMessage, setWarningMessage] = useState("");
  const { showInfoToast } = useToast();

  const handleToggle = (newType: "policy" | "claim" | null) => {
    if (newType !== null) {
      setIdType(newType);
    }
  };

  const handleSubmit = async () => {
    const policyParam = idType === "policy" ? idValue : undefined;
    const claimParam = idType === "claim" ? idValue : undefined;

    const response = await getClaimStatus(policyParam, claimParam);
    if (response.status === 200) {
      setShowClaimProgress(true);
      setClaimStatusData(response.data);
    } else {
      setShowWarning(true);
      setWarningMessage(response.data.message);
    }
  };

  const handleInputChange = (e: any) => {
    setIdValue(e.target.value);
  };
  const handleGoHome = () => {
    window.location.href = "/";
  };

  return (
    <Box>
      {showClaimProgress ? (
        <ClaimProgress
          claimStatusData={claimStatusData}
          handleGoHome={handleGoHome}
        />
      ) : (
        <PolicyInput
          handleSubmit={handleSubmit}
          handleInputChange={handleInputChange}
          inputValue={idValue}
          idType={idType}
          handleToggle={handleToggle}
        />
      )}
      <WarningPopup
        open={showWarning}
        onClose={() => setShowWarning(false)}
        warningMessage={warningMessage}
      />
    </Box>
  );
}
